<template>
  <div class="row" id="mixed-page">
    <div class="col s12">
      <RailObjectBreadCrumb :railObjectId.sync="railObjectId" @set-parent="setParent"/>
    </div>
    <div class="col s12">
      <div class="row" v-if="railObject">
        <ul id="switch-tabs" class="tabs z-depth-1">
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'Trend'}" @click="activeTab = 'Trend'">Trend</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'History'}" @click="activeTab = 'History'">History</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'Analysis'}" @click="activeTab = 'Analysis'">{{ $t('views.switch.tabs.analysis') }}</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'AlarmSettings'}" @click="activeTab = 'AlarmSettings'">{{ $t('views.switch.tabs.alarmsettings') }}</a></li>
        </ul>
        <div class="col s12 spacing-top">
          <Trend v-if="activeTab === 'Trend'" :railObject="railObject"></Trend>
          <History v-if="activeTab === 'History'"></History>
          <Analysis v-if="activeTab === 'Analysis'"></Analysis>
          <AlarmSettings v-if="activeTab === 'AlarmSettings'" :railObject="railObject"></AlarmSettings>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RailObjectService from '@/services/RailObjectService'
import RailObjectBreadCrumb from '@/components/RailObjectBreadCrumb'
import Trend from './_trend/Trend.vue'
import History from './_history.vue'
import Analysis from './_analysis.vue'
import AlarmSettings from './_alarmSettings.vue'

export default {
  data: function () {
    return {
      railObject: null,
      railObjectId: null,
      activeTab: 'Trend'
    }
  },
  components: {
    RailObjectBreadCrumb,
    Trend,
    History,
    Analysis,
    AlarmSettings
  },
  mounted: function () {
    this.railObjectId = parseInt(this.$route.params.railobjectid)
    this.load()
  },
  watch: {
    railObjectId (val) {
      this.$emit('set-parent', this.railObjectId)
    }
  },
  methods: {
    load () {
      this.railObject = RailObjectService.getRailObjectByRailObjectId(this.railObjectId)
    },
    setParent (val) {
      this.$emit('set-parent', this.railObjectId)
    }
  }
}
</script>

<style scoped>
#mixed-page {
  width: 100%;
  height: calc(100vh - 56px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.tabs-row-spacer {
  margin-bottom: 10px;
}

.tabs a:not(.active) {
  cursor: pointer;
}

.tabs .active {
  border-bottom: 2px solid #56CCF2;
}

.spacing-top {
  margin-top: 12px
}
</style>



// WEBPACK FOOTER //
// src/pages/mixedSignals/MixedSignals.vue